<div *ngIf="navData" fxLayoutGap="10px" class="data-wrap pt-0" fxLayout="column">
    <div class="title mt-0" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="5px">
        <mat-icon class="title-icon {{ navData.data.class }}">assignment_turned_in</mat-icon>
        <div class="title-label {{ navData.data.class }}" fxFlex="grow">{{ navData.data.title }}</div>
    </div>

    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
        <app-image-view
            [ngStyle]="{ minWidth: '50px' }"
            [isCircularImg]="true"
            [media_id]="navData.data.learner.media"
            paddingBottom="50px"
        ></app-image-view>
        <div fxLayout="column" fxLayoutAlign="center start">
            <span class="small">{{ navData.data.learner.name }}</span>
            <span class="dark-blue small">{{ navData.data.occasion.resource.title }}</span>
            <span
                *ngIf="navData.data.occasion?.signoff_at"
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="3px"
                class="small signoff-date"
                ><span i18n>Signoff</span> <span>{{ navData.data.occasion.signoff_at }}</span></span
            >
        </div>
    </div>
    <div class="mb-1 mt-1" fxLayout="row" fxLayoutAlign="flex-end center" fxLayoutGap="5px">
        <button
            [disabled]="navData.data.occasion.signoff_status === 'rejected'"
            fxFlex="0 0 auto"
            class="sub-btn rej"
            (click)="approved = false; submitEvaluation()"
            [ngClass]="{ disabled: navData.data.occasion.signoff_status === 'rejected' }"
            mat-button
        >
            <mat-icon>cancel</mat-icon>
            <span i18n>Reject</span>
        </button>
        <button
            [disabled]="navData.data.occasion.signoff_status === 'waiting'"
            fxFlex="0 0 auto"
            class="sub-btn orange"
            (click)="approved = null; submitEvaluation()"
            [ngClass]="{ disabled: navData.data.occasion.signoff_status === 'waiting' }"
            mat-button
        >
            <mat-icon>pending</mat-icon>
            <span i18n>Waitinglist</span>
        </button>
        <button
            [disabled]="navData.data.occasion.signoff_status === 'approved'"
            fxFlex="0 0 auto"
            class="sub-btn"
            (click)="approved = true; submitEvaluation()"
            [ngClass]="{ disabled: navData.data.occasion.signoff_status === 'approved' }"
            mat-button
        >
            <mat-icon>assignment_turned_in</mat-icon>
            <span i18n>Approve</span>
        </button>
    </div>
</div>
